import './ReferenceNames.css'
import { useSettings } from 'Settings'
import ValueTransform from 'ValueTransform'
import { v4 } from 'uuid'

const label_borders = {
	'v_bat_max_hi'     : ['solid', 'red'],
	'v_bat_max_lo'     : ['dashed', 'red'],
	'v_apl_max_hi'     : ['solid', 'yellow'],
	'v_apl_max_lo'     : ['dashed', 'yellow'],
	'v_bat_min_hi_dis' : ['solid', 'green'],
	'v_bat_min_hi_con' : ['solid', 'green'],
	'v_bat_min_lo'     : ['dashed', 'green'],
	'v_ulp_ldo'        : ['solid', 'purple'],
	'v_aux_ldo'        : ['dashed', 'purple'],
	'v_cs_hi'          : ['solid', 'gray'],
	'v_cs_lo'          : ['dashed', 'gray']
}

const getY = (value, rect, acc) => {
	let y = ValueTransform(value, acc)
	y = rect.y - y / rect.graph.height * rect.height
	y = parseInt(y / 32) * 32
	return y + 46
}

const getYnoTransform = (value, rect) => {
	let y = parseFloat(value)
	y = rect.y - y / rect.graph.height * rect.height
	y = parseInt(y / 32) * 32
	return y + 46
}

const getFloating = (rect, settings, values) => {
	let used = {}
	let global_x = 0

	let floating = {}

	Object.entries(values).forEach(([key, value]) => {
		if (used[value] === undefined) {
			floating[key] = ["left", false]
			used[value] = 1
		} else if (used[value] === 2) {
			floating[key] = ["left", true]
			used[value] += 1
		} else if (used[value] === 3) {
			floating[key] = ["right", true]
			used[value] += 1
		} else if (used[value] === 4) {
			floating[key] = [global_x]
			global_x += 130
		} else {
			floating[key] = ["right", false]
			used[value] += 1
		}
	})

	return floating
}

const getValues = (rect, settings) => {
	const acc = settings['supervisory level']['v_lvl_acc'].value
	const v_cs_acc = settings['cold-start accuracy']['v_cs_acc'].value
	const v_bat_max_hi = getY(settings['supervisory level']['v_bat_max_hi'].value, rect, acc)
	const v_bat_min_hi_dis = getY(settings['supervisory level']['v_bat_min_hi_dis'].value, rect, acc)
	const v_bat_min_hi_con = getY(settings['supervisory level']['v_bat_min_hi_con'].value, rect, acc)
	const v_bat_max_lo = getY(settings['supervisory level']['v_bat_max_lo'].value, rect, acc)
	const v_bat_min_lo = getY(settings['supervisory level']['v_bat_min_lo'].value, rect, acc)
	const v_apl_max_lo = getY(settings['supervisory level']['v_apl_max_lo'].value, rect, acc)
	const v_apl_max_hi = getY(settings['supervisory level']['v_apl_max_hi'].value, rect, acc)
	const v_ulp_ldo = getYnoTransform(settings['ldo levels']['v_ulp_ldo'].value, rect)
	const v_aux_ldo = getYnoTransform(settings['ldo levels']['v_aux_ldo'].value, rect)

	let v_cs_hi = 0
	let v_cs_lo = 0

	if (v_cs_acc === 'MAX') {
		v_cs_hi = 1.369
		v_cs_lo = 1.169
	} else {
		v_cs_hi = 1.3
		v_cs_lo = 1.1
	}

	v_cs_hi = getYnoTransform(v_cs_hi, rect)
	v_cs_lo = getYnoTransform(v_cs_lo, rect)

	return {
	'v_bat_max_hi' : v_bat_max_hi,
	'v_bat_max_lo' : v_bat_max_lo,
	'v_apl_max_hi' : v_apl_max_hi,
	'v_apl_max_lo' : v_apl_max_lo,
	'v_bat_min_hi_dis' : v_bat_min_hi_dis,
	'v_bat_min_hi_con' : v_bat_min_hi_con,
	'v_bat_min_lo' : v_bat_min_lo,
	'v_ulp_ldo' : v_ulp_ldo,
	'v_aux_ldo' : v_aux_ldo,
	'v_cs_hi' : v_cs_hi,
	'v_cs_lo' : v_cs_lo
	}
}

const ReferenceName = ({ rect, name, border, floating, y }) => {
	let className = "reference-name "
	const style = { top : `${y}px`}
	const divStyle = {}
	if (typeof floating[0] === 'string') {
		className += floating[0]

		if (floating[1]) {
			className += ' padded'
		}
	} else {
		className += 'left'
		style.top = 0
		divStyle.paddingLeft = floating[0]
	}

	return (
		<div
			style={style}
			className={className}
			>
			<div style={divStyle}>
				<span
					style={{ border: `${border[0]} var(--bs-${border[1]}) 1px` }}
					>{name}
				</span>
			</div>
		</div>
	)
}

const ReferenceNames = ({ rect }) => {
	const [settings] = useSettings()
	const values = getValues(rect, settings)
	const floating = getFloating(rect, settings, values)
	return (
		<>
			{
			Object.entries(values).map(([key, y]) => {
				return (
					<ReferenceName
						rect={rect}
						name={key}
						border={label_borders[key]}
						floating={floating[key]}
						y={y}
						key={v4()}
					/>
				)
			})
			}
		</>
	)
}

export default ReferenceNames
